// extracted by mini-css-extract-plugin
export default {"Logo":"Header_Logo__J4FKQ","Logos":"Header_Logos__2kYGc","Title":"Header_Title__p7TpL"};